import { render } from "./ResponseStatusCodesHelp.vue?vue&type=template&id=e00a1b34"
const script = {}
script.render = render

export default script